export type BookStepSync =
  | { kind: "none" }
  // The URL should show this step (it's missing, or a step change made in code).
  | { kind: "writeUrl"; step: number }
  // The step should follow the URL (native back/forward).
  | { kind: "followUrl"; step: number }
  // Both URL and step go back to this step: the URL asks for a step past the
  // traveler step, but the traveler selection (Redux only) didn't survive.
  | { kind: "restart"; step: number };

// In the travel app the `bookStep` URL param mirrors the checkout step so native
// back/forward moves between steps. Only a change of the param itself moves the
// step; otherwise the step wins and is written to the URL.
export const resolveBookStepSync = ({
  bookStepParam,
  previousBookStepParam,
  checkoutStep,
  hasSelectedTraveler,
  travelerStep,
  restartStep,
}: {
  bookStepParam: string | undefined;
  previousBookStepParam: string | undefined;
  checkoutStep: number;
  hasSelectedTraveler: boolean;
  travelerStep: number;
  restartStep: number;
}): BookStepSync => {
  if (bookStepParam == null) {
    return { kind: "writeUrl", step: checkoutStep };
  }

  const urlStep = Number(bookStepParam);
  if (urlStep > travelerStep && !hasSelectedTraveler) {
    return { kind: "restart", step: restartStep };
  }
  if (urlStep === checkoutStep) {
    return { kind: "none" };
  }
  return bookStepParam !== previousBookStepParam
    ? { kind: "followUrl", step: urlStep }
    : { kind: "writeUrl", step: checkoutStep };
};
